import axios from "axios";
import Fetch from "@/fetch/index";

const json = (body = {}) => ({ ...body, meta: { contentType: "application/json" } });
// Billing screens show their own error messages: skip the generic toast.
const quiet = { skipGlobalErrorHandler: true };

export function formatPrice(cents) {
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default {
  get: () => Fetch.get("/api/v1/billing").then((r) => r.data),
  checkout: (planIdentifier, cpfCnpj) =>
    axios
      .post("/api/v1/billing/checkout", json({ plan_identifier: planIdentifier, cpf_cnpj: cpfCnpj }), quiet)
      .then((r) => r.data),
  sync: () => axios.post("/api/v1/billing/sync", json(), quiet).then((r) => r.data),
  pix: () => axios.get("/api/v1/billing/pix", quiet).then((r) => r.data.pix),
  cancel: (reason) => axios.post("/api/v1/billing/cancel", json({ reason }), quiet).then((r) => r.data),
  discardPending: () => axios.post("/api/v1/billing/discard_pending", json(), quiet).then((r) => r.data),
  invoices: () => Fetch.get("/api/v1/billing/invoices").then((r) => r.data),
};
